var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightBulb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 38 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bulb-1--Streamline-Ultimate.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.25 29.3396V36.8396C24.25 37.5026 23.9866 38.1385 23.5178 38.6074C23.0489 39.0762 22.413 39.3396 21.75 39.3396H16.75C16.087 39.3396 15.4511 39.0762 14.9822 38.6074C14.5134 38.1385 14.25 37.5026 14.25 36.8396V29.3396",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.25 34.3396H24.25",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.25 1.8396V4.3396",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.75 19.3396H4.25",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.5 6.8396L7.33333 8.60627",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M36.75 19.3396H34.25",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M32.9998 6.8396L31.1665 8.60627",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M14.25 18.5063C14.913 18.5063 15.5489 18.7697 16.0178 19.2386C16.4866 19.7074 16.75 20.3433 16.75 21.0063V29.3397",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M21.75 29.3397V21.0063C21.75 20.3433 22.0134 19.7074 22.4822 19.2386C22.9511 18.7697 23.587 18.5063 24.25 18.5063",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M14.1166 29.3396H24.3833C26.2419 28.419 27.8024 26.9916 28.8847 25.2223C29.9669 23.4529 30.5269 21.4136 30.5 19.3396C30.4486 16.372 29.2468 13.5403 27.148 11.4415C25.0493 9.34276 22.2176 8.141 19.25 8.0896C16.2823 8.141 13.4506 9.34276 11.3519 11.4415C9.25312 13.5403 8.05135 16.372 7.99995 19.3396C7.973 21.4136 8.53297 23.4529 9.61524 25.2223C10.6975 26.9916 12.258 28.419 14.1166 29.3396Z",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulb);
export default __webpack_public_path__ + "static/media/lightBulb.b77371ad5318b6f14226f243e9dc6f7e.svg";
export { ForwardRef as ReactComponent };